// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"97222fb8","455":"d5fb849b","977":"d294dd0d"}[chunkId] + ".chunk.js";
};